import { CampaignWorkflowController } from './campaign-workflow.controller'

function campaignWorkflow () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-workflow/campaign-workflow.html?$$REVISION$$',
    controller: CampaignWorkflowController
  }
}

export { campaignWorkflow }
